import { Directive, ElementRef, HostBinding, HostListener  } from '@angular/core';

@Directive({
    selector: '[appTitleCase]',
    standalone: false
})
export class TitlecaseDirective {

  constructor(private el: ElementRef) { }
  
  @HostListener('input', ['$event'])
  onInput() {
    if (this.el.nativeElement.value) {
      const arr: string[] = this.el.nativeElement.value.split('');
      arr[0] = arr[0].toUpperCase();
      this.el.nativeElement.value = arr.join('');
   }
  }
}
